import React from 'react';
import { Button, Container, Typography } from '@mui/material';
import './SellYourMusicFirstSection.scss';
import UnifiedButton from '../../shared/Button';
import video from '../../../assets/Images/Sell your music/Sell your music video.mp4'

function SellYourMusicFirstSection() {



    const handleTryForFreeClick = () => {
        window.location.href = 'https://app.fmdigitalofficial.com/sign-up';
    };

    return (
        <div className="sell-music-section">
            {/* Background Video */}
            <video autoPlay muted loop className="background-video">
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="content-overlay">
                <Container className="content-container">
                    <Typography variant="h2" className="title">
                        Free <br />
                        Music <br />
                        Distribution.
                    </Typography>
                    <Typography variant="h2" className="title-no-fees">
                        No limits, no fees.
                    </Typography>
                    <Typography variant="body1" className="description">
                        Upload across all platforms and unlock access to our industry-leading tools.
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: '1.2rem', color: '#fff', fontWeight: 'bold', marginBottom: '20px' }}>
                        Absolutely free!
                    </Typography>
                    <UnifiedButton onClick={handleTryForFreeClick} textContent={"Try for Free"} variant="contained" color="primary" className="cta-button" />
                </Container>
            </div>
        </div>
    );
}

export default SellYourMusicFirstSection;
